import axios from "axios";
import config from "../config";

export function getWhatsappConfig() {
  return axios.get(`${config.api_url}/whatsapp/config`);
}

export function updateWhatsappConfig(body) {
  return axios.post(`${config.api_url}/whatsapp/config`, body);
}

export function addWhatsappNumber(body) {
  return axios.post(`${config.api_url}/whatsapp/config/add-number`, body);
}

export function removeWhatsappNumber(id) {
  return axios.patch(`${config.api_url}/whatsapp/config/remove-number/${id}`);
}
